import UserActionTypes from "../../actionTypes/user"

const addReferralAction = (referral) => (dispatch, getState) => {
  dispatch({
    type: UserActionTypes.ADD_REFERRAL_ACTION,
    payload: {
        referral: referral
    }
  });
};

export {
    addReferralAction
}
